import DefaultCell from "application/components/DefaultCell";



const getColumns = (onupdate) => {
  return [
    {
      Header: "Agent Id",
      accessor: "id",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent Name",
      accessor: "agentFullName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, };
